import { createTheme } from '@mui/material/styles';

const msiaTheme = createTheme({
    palette: {
        primary: {
            main: '#5E309F',       // bright-purple
        },
        secondary: {
            main: '#32145b',       // traveler-purple / dark purple
        },
        error: {
            main: '#db1818',       // $red
        },
        warning: {
            main: '#E1B34F',       // california-gold
        },
        info: {
            main: '#3b5171',       // spirit-blue (cc alpha suffix removed for MUI)
        },
        success: {
            main: '#199420',       // $green
        },
    },

    typography: {
        fontFamily: '"Montserrat", Arial, sans-serif',
        h1: { fontFamily: '"Lustria", "Times New Roman", Times, serif' },
        h2: { fontFamily: '"Lustria", "Times New Roman", Times, serif' },
        h3: { fontFamily: '"Lustria", "Times New Roman", Times, serif' },
        h4: { fontFamily: '"Lustria", "Times New Roman", Times, serif' },
        button: { textTransform: 'none' },
    },

    shape: {
        borderRadius: 6,
    },

    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    border: '1px solid #d8d8d8',   // $gray-border
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#9e9e9e',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5E309F',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#555555',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                },
            },
        },
    },
});

export default msiaTheme;
